const autoHyphen = value => {
  if (value) {
    const result = value
      .replace(/[^0-9]/, '')
      .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
    return result;
  }
};

export default autoHyphen;
